export default function PHP_preg_split() {
  return (
    <div>
      <h1>PHP_preg_split</h1>
    </div>
  );
}
